import { IUndergroundInfo, ETravelType } from 'shared/types/houseInfo/underground';

import {
  IconMapMetroMsk16,
  IconMapMetroSpb16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapWalk16,
  IconMapBus16,
  ISVGIconProps,
} from '@cian/ui-kit-design-tokens/icons';

import { UndergroundItem } from 'shared/components/TransportAccessibility';
import { FC } from 'react';
import { getValue } from './getValue';

const REGION_METRO_ICON_MAP = new Map<number, FC<ISVGIconProps>>([
  [1, IconMapMetroMsk16],
  [2, IconMapMetroSpb16],
  [4612, IconMapMetroEkb16],
  [4618, IconMapMetroKzn16],
  [4596, IconMapMetroNN16],
  [4598, IconMapMetroNovosib16],
  [4608, IconMapMetroSam16],
]);

const TRAVEL_TYPE_ICON_MAP = {
  walk: IconMapWalk16,
  transport: IconMapBus16,
};

export const renderUndergrounds = (undergrounds: IUndergroundInfo[], regionId: number) =>
  undergrounds.map((item, index) => {
    const travelType = getValue(item.travelType, ETravelType.Walk);
    const travelTypeIcon = TRAVEL_TYPE_ICON_MAP[travelType];
    const travelTime = item.travelTime ? `${item.travelTime} мин.` : /* istanbul ignore next */ undefined;
    const metroIcon = getValue(REGION_METRO_ICON_MAP.get(regionId), IconMapMetroMsk16);
    const iconColor = getValue(item.lineColor, '');

    return (
      <UndergroundItem
        key={index}
        icon={metroIcon}
        iconColor={iconColor}
        name={item.name}
        travelTypeIcon={travelTypeIcon}
        travelTime={travelTime}
      />
    );
  });
